import Login from '../../components/login';
import { connect } from 'react-redux';

import { devLogin } from '../../actions';
import {
    getUserInfo,
    getAuthentication,
    getDevLoginErrorMessage
} from '../../reducers';

const mapStateToProps = state => ({
    userInfo: getUserInfo(state),
    authentication: getAuthentication(state),
    errorMessage: getDevLoginErrorMessage(state)
});

const mapDispatchToProps = dispatch => ({
    devLogin: (username, password, history) =>
        dispatch(devLogin(username, password, history))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/containers/login/index.js